<div class="vendors-css vendors-background">
  <div class="row d-flex flex-dir-row vendor-advertise-section mb-3">
    <div class="d-flex" style="width: 50%">
      <div class="ps-3 vendor-notes">
        <div class="head"><u>TaxPlanIQ's</u> Vendor Marketplace</div>
        <div class="text">Enjoy exclusive benefits from our pre-vetted Partners across the states.</div>
      </div>
    </div>
    <div class="d-flex justify-content-end align-items-end" style="width: 50%">
      <div class="vendor-frame">
        <img src="../../../../images/vendors-page-icons/frame-icon.png"/>
      </div>
    </div>
  </div>
  <div class="row title-bar mb-3">
    <div class="title">TaxPlanIQ's Preferred Vendors</div>
  </div>

  <div class="row background-color">
    <div class="column large-4 medium-4 small-4" style="font-size: 14px !important;margin: 15px 0 5px 0;">
      <div style="border: 1px solid #D0D5DD;border-radius: 4px;padding: 5px 14px;">
        <input style="border-bottom: none !important;margin-bottom: 0;" type="text" [(ngModel)]="searchKey" placeholder="Search vendors" (keydown.enter)="filterData()" (keyup)="searchKeyUp()"/>
      </div>
    </div>
    <div class="column large-8 medium-8 small-8" style="font-size: 14px !important;margin: 15px 0 5px 0;">
      <div class="float-right" style="margin-right: 10px;">
        <div class="globalSearch" >
          <div class="search-field-header">
            <div class="pointer" style="border: 1px solid #D0D5DD;border-radius: 4px;padding: 10px 14px;">
              <img src="./images/tpiq-icons/SVG/filter.svg"> Filters
            </div>
          </div>
        </div>
      </div>
      <div class="float-right pointer" style="margin: 10px 10px;color: #1570EF;display: inline-flex;" (click)="addNewVendor()" *ngIf="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'">
        <i class="material-icons">add</i><span style="position: relative;top: 2px;">Create a new Vendor</span>
      </div>
    </div>
  </div>

  <div class="background-color" style="padding: 10px 15px 15px 15px;">
    <div class="row vendors-container" *ngIf="vendorsData && vendorsData.vendors && vendorsData.vendors.length == 0">
      <div class="small-12 medium-12 columns d-flex align-items-center justify-content-center" style="height: 20vh;">
        No data available.
      </div>
    </div>

    <div class="d-flex flex-wrap vendors-container" *ngIf="vendorsData && vendorsData.vendors && vendorsData.vendors.length > 0">
      <div class="d-flex flex-column vendor-details-sec" *ngFor="let vendor of vendorsData.vendors">
        <div class="vendor-logo mb-2 pointer" *ngIf="vendor.logo" (click)="viewVendor(vendor)" [ngStyle]="vendor.logoBg"></div>
        <div class="d-flex justify-content-between">
          <div class="vendor-title pointer" (click)="viewVendor(vendor)">{{vendor.name}}</div>
          <button mat-icon-button [matMenuTriggerFor]="beforeMenu" *ngIf="org === 'test-taxplaniq' ||org === 'stag-taxplaniq' || org === 'trialtaxplaniq'">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #beforeMenu="matMenu"  xPosition="before">
            <button mat-menu-item class="vendor-options" (click)="openVendor(vendor)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/edit.png"/>Edit</button>
            <button mat-menu-item class="vendor-options" (click)="viewVendor(vendor)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/eye.png"/>View</button>
            <button mat-menu-item class="vendor-options" (click)="deleteVendor(vendor)"><img style="margin-right: 5px;" src="../../../images/tpiq-icons/trash.png"/>Delete</button>
          </mat-menu>
        </div>
        <div class="vendor-description mb-3" *ngIf="vendor.description">
          <app-tpiq-froala-view [data]="vendor.description"></app-tpiq-froala-view>
        </div>
        <div class="d-flex flex-wrap" *ngIf="vendor.strategies && vendor.strategies.length > 0">
          <div class="vendor-strategy mb-2 pointer" (click)="showStrategy(strategy)" *ngFor="let strategy of vendor.strategies">{{strategy.strategyName}}</div>
        </div>
      </div>
    </div>
  </div>

</div>


<div *ngIf="reveal['addOrEditVendor']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['addOrEditVendor']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 75%;" [ngClass]="{'tpiq-reveal': reveal['addOrEditVendor']}">
    <div style="padding: 15px; color: #333333;">
      <span class="float-right pointer" (click)="hideReveal('addOrEditVendor')">X</span>
    </div>
    <div class="body" style="padding: 15px;">
      <app-create-or-update-vendor [editMode]="editMode" [vendorId]="vendorId" (onCancelCreateOrUpdateOfVendor)="hideReveal('addOrEditVendor')"
                                 (onCreationOrUpdateOfVendor)="refreshListOfVendors()"></app-create-or-update-vendor>
    </div>
  </div>
</div>



